import { appDependencies } from "../AppDependencies";
import { appDomain } from "../AppDomain";
import { EnumUserRole } from "../users/EnumUserRole";
import { LocalStorageKeys } from "../app/LocalStorageKeys";
import { IToken } from "./IToken";
import { IAuthenticationService } from "./IAuthenticationService";

export class AuthenticationService implements IAuthenticationService {

    getToken(): string {
        return appDependencies.ILocalRepository.getSync<IToken>(LocalStorageKeys.authToken).token;
    }

    isAuthenticated(): boolean {
        return appDependencies.IAuthenticationRepository.isAuthenticated();
    }

    async saveToken(token: IToken): Promise<boolean> {
        if (token && token.token) {
            await appDependencies.ILocalRepository.store(LocalStorageKeys.authToken, token);
            var userInfo = await appDomain.IEmployeeService.getUserInfo();
            await appDependencies.ILocalRepository.store(LocalStorageKeys.userType, userInfo.userType);
            return true;
        } else {
            this.loginRedirect();
            return false;
        }
    }

    loginRedirect(): Promise<any> {
        return appDependencies.IAuthenticationRepository.loginRedirect();
    }

    async logout() {
        await appDependencies.ILocalRepository.delete(LocalStorageKeys.userType);
        appDependencies.IAuthenticationRepository.logout();
    }

    getUserRole(): EnumUserRole {
        const userType = appDependencies.ILocalRepository.getSync<EnumUserRole>(LocalStorageKeys.userType);
        return userType || EnumUserRole.User;
    }

    getUserName(): string {
        return appDependencies.IAuthenticationRepository.getUserName();
    }

    getUserEmail(): string {
        return appDependencies.IAuthenticationRepository.getUserEmail();
    }
}
